import React from 'react'
import {Accordion, Typography,AccordionDetails, AccordionSummary} from '@mui/material';
import { ExpandMoreRounded } from '@mui/icons-material';
import TabletButton from './TabletButton';
export default function ExpandableToolbar({tools,editor}) {
    return (
        <div>
            <Accordion defaultExpanded elevation={0}>
                {/* <AccordionSummary
                    expandIcon={<ExpandMoreRounded />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>Tools</Typography>
                </AccordionSummary> */}
                <AccordionDetails>
                        {tools && tools.map((tool, index) => {
                            return <TabletButton editor={editor} key={index} icon={<tool.icon />} clickHandler={tool.clickHandler}/>
                        })}
                </AccordionDetails>
            </Accordion>
        </div>
    )
}
